import { useLocation, useNavigate } from "react-router-dom";
import { NavbarItems } from "./types";
import styles from "./navbar.module.scss";
import { routes } from "../../routes/routes";

export default function NavigationBar(_props: { navbarItems: NavbarItems[] }) {
  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname === routes.Login) {
    return null;
  }

  const handleLoginClick = () => {
    navigate(routes.Login);
  };

  return (
    <div className={styles.loginOnly}>
      <button className={styles.dropbtn} onClick={handleLoginClick}>
        Log In
      </button>
    </div>
  );
}
